import { render, staticRenderFns } from "./MicrophoneStatus.vue?vue&type=template&id=0c982faa&scoped=true"
import script from "./MicrophoneStatus.vue?vue&type=script&lang=js"
export * from "./MicrophoneStatus.vue?vue&type=script&lang=js"
import style0 from "./MicrophoneStatus.vue?vue&type=style&index=0&id=0c982faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c982faa",
  null
  
)

export default component.exports